jQuery(function ($) {

    /* ═══════════════════════════════════════════════════════════════════
     *  Button style
     * ═══════════════════════════════════════════════════════════════════ */

    const btnStyle = (qqv_ajax.button_style || 'absolute').trim();

    if (btnStyle !== 'absolute') {
        $('body').addClass('qqv-style--' + btnStyle);
    }

    /* ═══════════════════════════════════════════════════════════════════
     *  Quick-view buttons
     * ═══════════════════════════════════════════════════════════════════ */

    function addQuickViewButtons() {
        const cardSelector = (qqv_ajax.card_selector || '').trim() || '.custom-product-card';
        const idAttr       = (qqv_ajax.product_id_attr || '').trim();

        $(cardSelector).each(function () {
            const $card = $(this);
            if ($card.find('.qqv-btn').length > 0) return;

            // Ensure the card is positioned so absolute button modes work
            if (btnStyle !== 'static' && $card.css('position') === 'static') {
                $card.css('position', 'relative');
            }

            let productId = '';

            if (idAttr) {
                productId = ($card.attr(idAttr) || '').trim();
            }

            if (!productId) {
                const match = ($card.attr('class') || '').match(/post-(\d+)/);
                productId = match ? match[1] : '';
            }

            if (productId) {
                $card.append(`<button class="qqv-btn" data-product-id="${productId}">Quick View</button>`);
            }
        });
    }
    addQuickViewButtons();

    /* ═══════════════════════════════════════════════════════════════════
     *  Render Variations
     * ═══════════════════════════════════════════════════════════════════ */

    function renderVariations(attributes, swatches = {}, hasSizeGuide = false) {
        let html = '';

        Object.keys(attributes).forEach(attrName => {
            const options = normalizeOptions(attributes[attrName]);
            const isColor = swatches[attrName] !== undefined;
            const isSize = attrName.toLowerCase().includes('size');

            html += `<div class="qqv-attribute" data-attribute="${attrName}">`;

            // Attribute title row — show "Size guide" button next to size attrs
            html += `<div class="qqv-attribute__title">`;
            if (isColor) {
                html += `<span class="custom-product__select-name">${formatAttributeName(attrName)}</span>`;
            } else {
                html += formatAttributeName(attrName);
            }
            if (isSize && hasSizeGuide) {
                html += `<button type="button" class="qqv-size-guide-btn" aria-haspopup="dialog">
                    Size guide
                 </button>`;
            }
            html += `</div>`; // .qqv-attribute__title

            if (!isColor && !isSize) {
                html += `<div class="qqv-attribute__options qqv-attribute__options--select">`;
                html += `<div class="qqv-select-wrapper">`;
                html += `<select class="qqv-select" data-attribute="${attrName}">`;
                html += `<option value="">— ${formatAttributeName(attrName)} —</option>`;
                options.forEach(option => {
                    html += `<option value="${option}">${option}</option>`;
                });
                html += `</select></div></div>`;
            } else {
                html += `<div class="qqv-attribute__options ${isColor ? 'qqv-attribute__options--color' : ''}">`;
                options.forEach(option => {
                    if (isColor && swatches[attrName][option]) {
                        const color = swatches[attrName][option];
                        html += `
            <button type="button"
                class="qqv-option qqv-option--color"
                data-attribute="${attrName}"
                data-value="${option}"
                title="${option}">
                <span style="background:${color}"></span>
            </button>`;
                    } else {
                        html += `
            <button type="button"
                class="qqv-option"
                data-attribute="${attrName}"
                data-value="${option}">
                ${option}
            </button>`;
                    }
                });
                html += `</div>`;
            }
            html += `</div>`;
        });

        $('.qqv-variations').html(html);
        updateOptionStates();
    }

    /* ── helpers ─────────────────────────────────────────────────────── */

    function normalizeOptions(options) {
        if (Array.isArray(options)) return options;
        if (typeof options === 'string') return options.split('|').map(o => o.trim());
        if (typeof options === 'object' && options !== null) return Object.values(options);
        return [];
    }

    function formatAttributeName(name) {
        return name
            .replace('attribute_', '')
            .replace('pa_', '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
    }

    function normKey(key) {
        return key.startsWith('attribute_') ? key : 'attribute_' + key;
    }

    function isOptionAvailable(attrName, value, selected, variations) {
        const testKey = normKey(attrName);
        return variations.some(v => {
            if (!v.is_in_stock) return false;
            const varVal = v.attributes[testKey];
            if (varVal !== '' && varVal !== value) return false;
            for (const [selKey, selVal] of Object.entries(selected)) {
                const selNorm = normKey(selKey);
                if (selNorm === testKey) continue;
                const varSelVal = v.attributes[selNorm];
                if (varSelVal !== '' && varSelVal !== selVal) return false;
            }
            return true;
        });
    }

    function updateOptionStates() {
        if (!window.qqvState?.variations) return;
        const variations = window.qqvState.variations;
        const selected = qqvSelectedAttributes;

        $('.qqv-option').each(function () {
            const $opt = $(this);
            const attr = $opt.data('attribute');
            const value = $opt.data('value');
            const available = isOptionAvailable(attr, value, selected, variations);
            $opt.toggleClass('is-unavailable', !available);

            if (!available && $opt.hasClass('is-active')) {
                $opt.removeClass('is-active');
                const nk = normKey(attr);
                delete selected[nk];
                delete selected[attr];
            }
        });

        $('.qqv-select').each(function () {
            const $select = $(this);
            const attr = $select.data('attribute');
            const currentVal = $select.val();

            $select.find('option').each(function () {
                const value = $(this).val();
                if (!value) return;
                const available = isOptionAvailable(attr, value, selected, variations);
                $(this).prop('disabled', !available);
            });

            if (currentVal && $select.find(`option[value="${currentVal}"]`).prop('disabled')) {
                $select.val('');
                const nk = normKey(attr);
                delete selected[nk];
                delete selected[attr];
            }
        });
    }

    function applyDefaultSelection(defaultAttrs, variations) {
        const defaults = {};
        Object.entries(defaultAttrs || {}).forEach(([k, v]) => {
            if (v) defaults[normKey(k)] = v;
        });

        $('.qqv-attribute').each(function () {
            const attrName = $(this).data('attribute');
            const nk = normKey(attrName);
            const $select = $(this).find('.qqv-select');

            if ($select.length) {
                const defaultVal = defaults[nk];
                if (defaultVal && $select.find(`option[value="${defaultVal}"]`).not(':disabled').length) {
                    $select.val(defaultVal).trigger('change');
                } else {
                    const $first = $select.find('option[value!=""]').not(':disabled').first();
                    if ($first.length) $select.val($first.val()).trigger('change');
                }
                return;
            }

            if (defaults[nk]) {
                const $opt = $(this).find(`.qqv-option[data-value="${defaults[nk]}"]`).not('.is-unavailable').first();
                if ($opt.length) { $opt.trigger('click'); return; }
            }

            const $first = $(this).find('.qqv-option').not('.is-unavailable').first();
            if ($first.length) $first.trigger('click');
        });
    }

    /* ═══════════════════════════════════════════════════════════════════
     *  Quick-view open
     * ═══════════════════════════════════════════════════════════════════ */

    let qqvSelectedAttributes = {};

    function lockScroll() { $('body').addClass('qqv-no-scroll'); }
    function unlockScroll() {
        if (!$('#qqv-modal').is(':visible') && !$('#qqv-sg-modal').is(':visible')) {
            $('body').removeClass('qqv-no-scroll');
        }
    }

    $(document).on('click', '.qqv-btn', function (e) {
        e.preventDefault();
        qqvSelectedAttributes = {};

        const $btn = $(this);
        const productId = $btn.data('product-id');
        if ($btn.hasClass('is-loading')) return;

        $btn.addClass('is-loading');
        if (!$btn.data('original-text')) $btn.data('original-text', $btn.html());
        $btn.html('<span class="qqv-loader"></span>');

        $.post(qqv_ajax.url, { action: 'qqv_get', product_id: productId })
            .done(function (response) {
                if (!response.success) return;

                const d = response.data;

                $('#qqv-modal .qqv-product__title').text(d.title).removeAttr('aria-busy');
                if (d.sku) $('#qqv-modal .qqv-product__sku').text('SKU: ' + d.sku);
                $('#qqv-modal .qqv-modal__content-link').attr('href', d.permalink);
                $('#qqv-modal .qqv-product__price').html(d.price);
                $('#qqv-modal').attr('data-product-id', d.product_id);
                $('#qqv-modal').attr('data-product-type', d.type);

                window.qqvState = {
                    productId: d.product_id,
                    variations: d.variations,
                    sizeGuide: d.size_guide || null,
                };

                // Stock
                $('#qqv-modal .qqv-product__stock')
                    .removeClass('in-stock last-stock sold-out-stock')
                    .addClass(d.stock.class)
                    .text(d.stock.text);

                // Gallery
                const galleryHtml = `
          <div class="qqv-swiper swiper">
            <div class="swiper-wrapper">
              ${d.gallery.map(img => `<div class="swiper-slide"><img src="${img}" alt=""></div>`).join('')}
            </div>
          </div>
          <div class="qqv-swiper__arrow qqv-swiper__next">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 12L17.5 12M17.5 12L11.5 18M17.5 12L11.5 6" stroke="#1C2230" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="qqv-swiper__arrow qqv-swiper__prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17.5 12L6 12M6 12L12 18M6 12L12 6" stroke="#1C2230" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>`;
                $('#qqv-modal .qqv-modal__gallery').html(galleryHtml);

                // Description
                if (d.description) {
                    $('#qqv-modal .qqv-product__description').html(d.description);
                    $('#qqv-modal .qqv-accordion__item--desc').show();
                } else {
                    $('#qqv-modal .qqv-accordion__item--desc').hide();
                }

                // Characteristics
                if (d.characteristics) {
                    $('#qqv-modal .qqv-product__char').html(d.characteristics);
                    $('#qqv-modal .qqv-accordion__item--char').show();
                } else {
                    $('#qqv-modal .qqv-accordion__item--char').hide();
                }

                // Variations
                if (d.type === 'variable') {
                    window.qqvVariations = d.variations;
                    renderVariations(d.attributes, d.swatches, !!d.size_guide);
                    applyDefaultSelection(d.default_attributes, d.variations);
                } else {
                    $('.qqv-variations').html('');
                    $('.qqv-add-to-cart').prop('disabled', false);
                }

                // Show modal
                updateMinusBtn($('#qqv-modal .qqv-quantity__input'));
                lockScroll();
                $('#qqv-modal').fadeIn(200, function () {
                    if (window.qqvSwiper) window.qqvSwiper.destroy(true, true);
                    window.qqvSwiper = new Swiper('.qqv-swiper', {
                        slidesPerView: 1,
                        loop: true,
                        navigation: { nextEl: '.qqv-swiper__next', prevEl: '.qqv-swiper__prev' },
                    });

                    // Store the original src of the main product image (real slide index 0)
                    // so it can be restored when a variation without its own image is selected
                    const $mainSlide = $('.qqv-swiper .swiper-slide[data-swiper-slide-index="0"]').first();
                    window.qqvState.originalFirstSlideSrc = $mainSlide.find('img').attr('src') || '';
                });
            })
            .always(function () {
                $btn.removeClass('is-loading').html($btn.data('original-text'));
            });
    });

    /* ─── Close quick-view modal ─────────────────────────────────────── */

    $(document).on('click', '.qqv-modal__close, .qqv-modal__overlay', function () {
        $('#qqv-modal').fadeOut(200, unlockScroll);
    });

    /* ─── MutationObserver ───────────────────────────────────────────── */

    const observer = new MutationObserver(() => addQuickViewButtons());
    observer.observe(document.body, { childList: true, subtree: true });

    /* ═══════════════════════════════════════════════════════════════════
     *  SIZE GUIDE modal
     * ═══════════════════════════════════════════════════════════════════ */

    /**
     * Build and inject the table for the given unit ("cm" or "inches").
     * @param {Object} guide  - { cm: {cols, rows}, inches: {cols, rows} }
     * @param {string} unit   - "cm" | "inches"
     */

    function sgEscape(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function renderSizeGuideTable(guide, unit) {
        const table = guide[unit];
        const isInches = unit === 'inches';

        // HEAD
        const headCols = (table.cols || [])
            .map(col => `<th class="qqv-sg-table__th">${sgEscape(col)}</th>`)
            .join('');
        $('#qqv-sg-modal .qqv-sg-table__head-row').html(
            `<th class="qqv-sg-table__th qqv-sg-table__th--label"></th>${headCols}`
        );

        // BODY
        const bodyRows = (table.rows || []).map(row => {
            const cells = (row.values || [])
                .map(val => {
                    const display = val && isInches ? sgEscape(val) + '<span style="font-style: italic;">&quot</span>' : sgEscape(val);
                    return `<td class="qqv-sg-table__td">${display}</td>`;
                })
                .join('');
            return `<tr class="qqv-sg-table__row">
                <td class="qqv-sg-table__td qqv-sg-table__td--label">${sgEscape(row.label || '')}</td>
                ${cells}
              </tr>`;
        }).join('');

        $('#qqv-sg-modal .qqv-sg-table__body').html(bodyRows);
        $('#qqv-sg-modal .qqv-sg-table').removeAttr('aria-busy');
    }

    /** Open size guide modal and render default unit (cm first, or inches if only inches has data). */
    $(document).on('click', '.qqv-size-guide-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const guide = window.qqvState?.sizeGuide;
        if (!guide) return;

        // Pick initial unit
        const initialUnit = guide.cm?.cols?.length ? 'inches' : 'cm';

        // Reset tabs
        $('#qqv-sg-modal .qqv-sg-modal__tab')
            .removeClass('is-active')
            .filter(`[data-unit="${initialUnit}"]`)
            .addClass('is-active');

        // Hide tabs that have no data
        $('#qqv-sg-modal .qqv-sg-modal__tab').each(function () {
            const u = $(this).data('unit');
            const hasData = guide[u]?.cols?.length > 0;
            $(this).toggle(hasData);
        });

        renderSizeGuideTable(guide, initialUnit);
        lockScroll();
        $('#qqv-sg-modal').fadeIn(200);
    });

    /** Switch unit tab */
    $(document).on('click', '.qqv-sg-modal__tab', function () {
        const unit = $(this).data('unit');
        const guide = window.qqvState?.sizeGuide;
        if (!guide) return;

        $(this).closest('.qqv-sg-modal__tabs').find('.qqv-sg-modal__tab').removeClass('is-active');
        $(this).addClass('is-active');

        renderSizeGuideTable(guide, unit);
    });

    /** Close size guide modal */
    $(document).on('click', '.qqv-sg-modal__close, .qqv-sg-modal__overlay', function () {
        $('#qqv-sg-modal').fadeOut(200, unlockScroll);
    });

    /** Close on Escape */
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            if ($('#qqv-sg-modal').is(':visible')) {
                $('#qqv-sg-modal').fadeOut(200, unlockScroll);
            } else {
                $('#qqv-modal').fadeOut(200, unlockScroll);
            }
        }
    });

    /* ═══════════════════════════════════════════════════════════════════
     *  Accordion
     * ═══════════════════════════════════════════════════════════════════ */

    $(document).on('click', '.qqv-accordion__header', function () {
        const $item = $(this).closest('.qqv-accordion__item');
        const $content = $item.find('.qqv-accordion__content');
        $item.toggleClass('is-open');
        $content.stop().slideToggle(200);
    });

    /* ═══════════════════════════════════════════════════════════════════
     *  Quantity
     * ═══════════════════════════════════════════════════════════════════ */

    function updateMinusBtn($input) {
        $input.siblings('.qqv-quantity__minus')
            .toggleClass('qqv-quantity__minus--disabled', parseInt($input.val()) <= 1);
    }

    $(document).on('click', '.qqv-quantity__plus', function () {
        const $input = $(this).siblings('.qqv-quantity__input');
        $input.val(parseInt($input.val()) + 1).change();
        updateMinusBtn($input);
    });

    $(document).on('click', '.qqv-quantity__minus', function () {
        const $input = $(this).siblings('.qqv-quantity__input');
        const val = parseInt($input.val());
        if (val > 1) {
            $input.val(val - 1).change();
            updateMinusBtn($input);
        }
    });

    $(document).on('change', '.qqv-quantity__input', function () {
        updateMinusBtn($(this));
    });

    /* ═══════════════════════════════════════════════════════════════════
     *  Choose variation
     * ═══════════════════════════════════════════════════════════════════ */

    $(document).on('click', '.qqv-option', function () {
        const $btn = $(this);
        if ($btn.hasClass('is-unavailable')) return;

        const attr = $btn.data('attribute');
        const value = $btn.data('value');
        const normalizedAttr = attr.startsWith('attribute_') ? attr : 'attribute_' + attr;

        qqvSelectedAttributes[normalizedAttr] = value;
        $btn.closest('.qqv-attribute').find('.qqv-option').removeClass('is-active');
        $btn.addClass('is-active');

        if ($btn.hasClass('qqv-option--color')) {
            $btn.closest('.qqv-attribute').find('.custom-product__select-name').text(value);
        }

        $('#qqv-modal .qqv-notice').hide();
        updateOptionStates();

        const allAttrKeys = [...new Set(window.qqvState.variations.flatMap(v => Object.keys(v.attributes)))];
        const hasAll = allAttrKeys.every(nk => !!qqvSelectedAttributes[nk]);
        $('.qqv-add-to-cart').prop('disabled', !hasAll);

        const match = findVariation(window.qqvState.variations, qqvSelectedAttributes);
        if (match?.price_html) {
            $('#qqv-modal .qqv-product__price').html(match.price_html);
        }

        // Update the main gallery slide to show the variation image (or restore original)
        switchGalleryToVariationImage(match?.image || '');
    });

    /* ─── Select attribute change ───────────────────────────────────── */

    $(document).on('change', '.qqv-select', function () {
        const $select = $(this);
        const attr = $select.data('attribute');
        const value = $select.val();
        const normalizedAttr = attr.startsWith('attribute_') ? attr : 'attribute_' + attr;

        if (value) {
            qqvSelectedAttributes[normalizedAttr] = value;
        } else {
            delete qqvSelectedAttributes[normalizedAttr];
            delete qqvSelectedAttributes[attr];
        }

        $('#qqv-modal .qqv-notice').hide();
        updateOptionStates();

        if (!window.qqvState?.variations) return;
        const allAttrKeys = [...new Set(window.qqvState.variations.flatMap(v => Object.keys(v.attributes)))];
        const hasAll = allAttrKeys.every(nk => !!qqvSelectedAttributes[nk]);
        $('.qqv-add-to-cart').prop('disabled', !hasAll);

        const match = findVariation(window.qqvState.variations, qqvSelectedAttributes);
        if (match?.price_html) {
            $('#qqv-modal .qqv-product__price').html(match.price_html);
        }
        switchGalleryToVariationImage(match?.image || '');
    });

    /* ─── Find matching variation ────────────────────────────────────── */

    function findVariation(variations, selected) {
        return variations.find(v => {
            const vAttrs = v.attributes;
            for (const [key, value] of Object.entries(selected)) {
                const nk = key.startsWith('attribute_') ? key : 'attribute_' + key;
                const varVal = vAttrs[nk];
                if (varVal !== '' && varVal !== value) return false;
            }
            for (const [nk, varVal] of Object.entries(vAttrs)) {
                if (varVal === '') continue;
                const shortKey = nk.replace('attribute_', '');
                const selVal = selected[nk] ?? selected[shortKey];
                if (selVal !== varVal) return false;
            }
            return true;
        });
    }

    function normalizeVariation(selected) {
        const out = {};
        Object.entries(selected).forEach(([key, value]) => {
            const nk = key.startsWith('attribute_') ? key : 'attribute_' + key;
            out[nk] = value;
        });
        return out;
    }

    /* ─── Switch main gallery slide to variation image ───────────────── */
    function switchGalleryToVariationImage(imgSrc) {
        if (!window.qqvSwiper) return;

        const src = imgSrc || window.qqvState?.originalFirstSlideSrc || '';

        // Update every DOM node that represents logical slide 0
        $('.qqv-swiper .swiper-slide[data-swiper-slide-index="0"]').find('img').attr('src', src);

        // Navigate to logical slide index 0
        window.qqvSwiper.slideToLoop(0, 300);
    }

    /* ═══════════════════════════════════════════════════════════════════
     *  Add to cart
     * ═══════════════════════════════════════════════════════════════════ */

    $(document).on('click', '.qqv-add-to-cart', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const productId = parseInt($('#qqv-modal').attr('data-product-id'));
        const productType = $('#qqv-modal').attr('data-product-type');
        const variations = window.qqvState.variations;
        const qty = parseInt($('.qqv-qty').val()) || 1;

        let data = { product_id: productId, quantity: qty };

        if (productType === 'variable') {
            const selected = qqvSelectedAttributes;
            const allAttrKeys = [...new Set(variations.flatMap(v => Object.keys(v.attributes)))];
            const hasAll = allAttrKeys.every(nk => !!selected[nk]);

            if (!hasAll) {
                $('#qqv-modal .qqv-notice').text('Please select all options').show();
                return;
            }

            const match = findVariation(variations, selected);
            if (!match) {
                $('#qqv-modal .qqv-notice').text('This combination is not available').show();
                return;
            }
            if (!match.is_in_stock) {
                $('#qqv-modal .qqv-notice').text('This variation is out of stock').show();
                return;
            }

            $('#qqv-modal .qqv-notice').hide();
            data.variation_id = match.variation_id;
            data.variation = normalizeVariation(selected);
        }

        addToCartAjax(data, $(this));
    });

    /* ═══════════════════════════════════════════════════════════════════
     *  Toast
     * ═══════════════════════════════════════════════════════════════════ */

    function showCartToast(message = 'Product added to cart', type = 'success', showLink = false) {
        const $toast = $('#qqv-toast');
        $toast.removeClass('qqv-toast--success qqv-toast--error').addClass('qqv-toast--' + type);
        $toast.find('.qqv-toast__text').text(message);
        $toast.find('.qqv-toast__link').toggle(showLink);
        $toast.stop(true, true).fadeIn(200);
        clearTimeout(window.qqvToastTimer);
        window.qqvToastTimer = setTimeout(() => $toast.fadeOut(200), type === 'error' ? 5000 : 3000);
    }

    $(document).on('click', '.qqv-toast__close', function () {
        clearTimeout(window.qqvToastTimer);
        $('#qqv-toast').fadeOut(200);
    });

    /* ─── AJAX helper ────────────────────────────────────────────────── */

    function addToCartAjax(data, $btn) {
        $btn.addClass('loading').prop('disabled', true);

        const flatData = {
            action: 'qqv_add_to_cart',
            nonce: qqv_ajax.nonce,
            product_id: data.product_id,
            quantity: data.quantity,
            variation_id: data.variation_id || 0,
        };

        Object.entries(data.variation || {}).forEach(([key, val]) => {
            flatData[`variation[${key}]`] = val;
        });

        $.ajax({
            type: 'POST',
            url: qqv_ajax.url,
            data: flatData,
            success(response) {
                console.log('qqv add to cart response:', response);
                if (!response) return;
                if (response.error) {
                    $('#qqv-modal .qqv-notice').text('Could not add to cart. Please try again.').show();
                    return;
                }
                if ((qqv_ajax.cart_behaviour || 'mini_cart') === 'toast') {
                    showCartToast('Product added to cart', 'success', true);
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $btn]);
                }
            },
            error() {
                $('#qqv-modal').fadeOut(200, unlockScroll);
                showCartToast('Network error. Please try again.', 'error');
            },
            complete() {
                $('#qqv-modal').fadeOut(200, unlockScroll);
                $btn.removeClass('loading').prop('disabled', false);
            },
        });
    }

    /* ═══════════════════════════════════════════════════════════════════
   *  Size Guide button — Single Product page
   *
   *  .custom-sg-btn is rendered by custom_product_variations_ui_with_sg()
   *  in woocommerce-setup.php. It reuses the same #qqv-sg-modal shell
   *  that the Quick View plugin already outputs in wp_footer.
   *  Guide data comes from window.qqvSingleSizeGuide injected by
   *  custom_single_size_guide_data() also in woocommerce-setup.php.
   * ═══════════════════════════════════════════════════════════════════ */

    $(document).on('click', '.custom-sg-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const guide = window.qqvSingleSizeGuide;
        if (!guide) return;

        // Push data into the shared qqvState so renderSizeGuideTable() works
        window.qqvState = window.qqvState || {};
        window.qqvState.sizeGuide = guide;

        // Pick initial unit (cm first, fall back to inches)
        const initialUnit = guide.cm?.cols?.length ? 'inches' : 'cm';

        // Reset + configure tabs
        $('#qqv-sg-modal .qqv-sg-modal__tab')
            .removeClass('is-active')
            .filter(`[data-unit="${initialUnit}"]`)
            .addClass('is-active');

        $('#qqv-sg-modal .qqv-sg-modal__tab').each(function () {
            const u = $(this).data('unit');
            const hasData = guide[u]?.cols?.length > 0;
            $(this).toggle(hasData);
        });

        renderSizeGuideTable(guide, initialUnit);
        lockScroll();
        $('#qqv-sg-modal').fadeIn(200);
    });
});